(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('followup-type', {
            parent: 'entity',
            url: '/followup-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-type/followup-types.html',
                    controller: 'FollowupTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('followup-type-detail', {
            parent: 'entity',
            url: '/followup-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-type/followup-type-detail.html',
                    controller: 'FollowupTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FollowupType', function($stateParams, FollowupType) {
                    return FollowupType.get({id : $stateParams.id});
                }]
            }
        })
        .state('followup-type.new', {
            parent: 'followup-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-type/followup-type-dialog.html',
                    controller: 'FollowupTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('followup-type', null, { reload: true });
                }, function() {
                    $state.go('followup-type');
                });
            }]
        })
        .state('followup-type.edit', {
            parent: 'followup-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-type/followup-type-dialog.html',
                    controller: 'FollowupTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FollowupType', function(FollowupType) {
                            return FollowupType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('followup-type.delete', {
            parent: 'followup-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-type/followup-type-delete-dialog.html',
                    controller: 'FollowupTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FollowupType', function(FollowupType) {
                            return FollowupType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
